import React, { useState } from 'react'
import RateCompareSection from './rateCompareSection'
import DistributionSection from './distributionSection'
import useSWR from 'swr'
import { getData } from '../sfc/component-helpers/requesthelpers'

let allUSDataURL =
  'https://files.sfchronicle.com/vaccine-tracker/allus_vaccinations_bignums.json'

const stateNameEdits = {
  'New York State': 'New York',
  'Republic of Palau': 'Palau',
  'Dept of Defense': 'Department of Defense',
  'Indian Health Svc': 'Indian Health Service',
  'Veterans Health': 'Veterans Health Administration',
}

function AllUSSection({ MARKET_STATE, marketKey }) {
  let [activeStateObj, setActiveStateObj] = useState(null)
  let [allUSData, setAllUSData] = useState(null)
  let [modDate, setModDate] = useState(null)

  const { data, dataError } = useSWR(allUSDataURL, getData, {
    onSuccess: (data) => {
      let filtered = []
      let activeStateData = {}

      data.data.forEach((d) => {
        //filter out bad data and replace names if needed
        // if (d['pop'] !== -1 && d['1'] > 0) {
        //   if (stateNameEdits[d.n]) {
        //     d.n = stateNameEdits[d.n]
        //   }
        //   filtered.push(d)
        // }

        //find current state
        if (d.n === MARKET_STATE) {
          activeStateData = d
        }
      })

      //remove from index and add back to the front
      let activeIndex = data.data.indexOf(activeStateData)

      data.data.splice(activeIndex, 1)
      data.data.unshift(activeStateData)

      setAllUSData(data.data)
      setActiveStateObj(activeStateData)
      setModDate(data.mod_date)
    },
    // onError: (err) => console.log(err),
  })
  return (
    <>
      {allUSData && activeStateObj && (
        <>
          <RateCompareSection
            activeStateObj={activeStateObj}
            allUSData={allUSData}
            modDate={modDate}
            marketKey={marketKey}
          />

          <DistributionSection
            MARKET_STATE={MARKET_STATE}
            activeStateObj={activeStateObj}
            allUSData={allUSData}
            modDate={modDate}
            marketKey={marketKey}
          />
        </>
      )}
    </>
  )
}

export default React.memo(AllUSSection)
